import Flag from '@atlaskit/flag';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import React from 'react';
// import ScreenEventAnalytics from '../../../../../common/analytics/components/screen-event-analytics';
// import { AnalyticsEventSource } from '../../../analytics/constants';
import { ChatRoomLink, ServiceDeskLink } from '../help-links';
import '../shared.scss';
import './server-error.scss';
import { ErrorTypeEnum, PanelTypeEnum } from '../constants';
import { ReportError } from '../error-reporting';

export const ServerError = (props: {
  error?: Error;
  description?: React.ReactNode;
  enableReporting?: boolean;
  enableTicketCreationOption?: boolean;
}) => {
  const { enableReporting = false, enableTicketCreationOption = false } = props;
  return (
    <div className="not-found" data-testid="serverError">
      {/* <ScreenEventAnalytics
            event={{
                name: AnalyticsEventSource.ERROR_SCREEN
            }}
        /> */}
      <div className="error-report-container">
        <Flag
          title="Server Error"
          description={
            props.description ?? (
              <>
                <p>
                  An unrecoverable system error has occurred. Please consult the Advocate Central team via the{' '}
                  <ChatRoomLink /> or <ServiceDeskLink /> for assistance.
                </p>
                {props.error && (
                  <p>
                    <strong>Error:</strong> <code>{props.error.message}</code>
                  </p>
                )}
              </>
            )
          }
          appearance="normal"
          id="server-error"
          icon={<WarningIcon label="Server error" />}
        />
        {enableReporting && (
          <ReportError
            errorMessage={props.error ? props.error.message : 'An unrecoverable system error has occurred.'}
            type={PanelTypeEnum.ERROR_PANEL}
            enableTicketCreationOption={enableTicketCreationOption}
          />
        )}
      </div>
    </div>
  );
};
// this is used by error-wrapper for identifying the component
ServerError.displayName = ErrorTypeEnum.SERVER_ERROR;
